<script lang="ts">
    import Fa from 'svelte-fa'
    import { faAngleLeft, faPlusCircle, faSave, faTrashAlt, faUser } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, get_current_component, onMount } from 'svelte/internal'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridItemShow, GridLine } from '../_common/z/zgrid'
    import Zframe from '../_common/z/zframe.svelte'
    import Zact from '../_common/z/zact.svelte'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import { PartnerPerson } from '../../modules/toolsApi/partners/persons/partner-person.entity'
    import type { CreatePartnerPersonDto } from '../../modules/toolsApi/partners/persons/dto/create-partner-person.dto'
    import type { UpdatePartnerPersonDto } from '../../modules/toolsApi/partners/persons/dto/update-partner-person.dto'
    import type { Partner } from '../../modules/toolsApi/partners/partners/partner.entity'
    import dayjs from 'dayjs'
    const dispatch = createEventDispatcher()

    const me = get_current_component()

    let show = false
    let step = 1
    let entities: PartnerPerson[] = []
    let entity: PartnerPerson = new PartnerPerson()
    let startAt: string = null
    let partnerId: string = null

    let partners: Partner[] = []

    onMount(async () => {
        await loadPartners()
        await loadEntities()
    })

    async function loadPartners() {
        partners = await window.api.tools.partners.partners.getAll()
        partners = await window.api.utils.utils.assignPersonsFromObject(partners)
    }

    async function loadEntities() {
        try {
            show = true
            entities = []
            entities = await window.api.tools.partners.persons.getAll({ partnerId })
            console.log('persons', entities)
            // assign persons (referrals/indicados)
            entities = await window.api.utils.utils.assignPersonsFromObject(entities)
            // assign partners
            for (let entity of entities) {
                const personId = partners.find((el) => el.partnerId === entity.partnerId)?.personId
                if (personId) {
                    entity['partnerPersonId'] = personId
                }
            }
            entities = await window.api.utils.utils.assignPersonsFromObject(entities, 'partnerPersonId', 'partner')
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function editEntity(id: string) {
        try {
            show = true
            entity = new PartnerPerson()
            entity = await window.api.tools.partners.persons.getOne(id)
            entity = await window.api.utils.utils.assignPersonsFromObject(entity)
            startAt = dayjs(entity.startAt).format('YYYY-MM-DD')
            console.log('partner', startAt)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new PartnerPerson()
        startAt = dayjs(new Date()).format('YYYY-MM-DD')
        step = 2
    }

    async function saveEntity() {
        if (entity.partnersPersonsId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function createEntity() {
        try {
            show = true
            entity.startAt = window.api.utils.dates.setDateStringToLocalMidnight(startAt)
            const dto: CreatePartnerPersonDto = {
                personId: entity.personId || entity.person?.personId,
                partnerId: entity.partnerId,
                startAt: entity.startAt,
                status: entity.status,
            }
            entity = await window.api.tools.partners.persons.create(dto)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            entity.startAt = window.api.utils.dates.setDateStringToLocalMidnight(startAt)
            const dto: UpdatePartnerPersonDto = {
                partnerId: entity.partnerId,
                startAt: entity.startAt,
                status: entity.status,
            }
            await window.api.tools.partners.persons.update(entity.partnersPersonsId, dto)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.tools.partners.persons.remove(entity.partnersPersonsId)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Indicados'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Indicado' }))
        grid.cols.push(new GridCol({ content: 'Parceiro' }))
        grid.cols.push(new GridCol({ content: 'Inclusão', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Indicação', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let btnPerson = new GridButton({
                icon: faUser,
                label: '',
                mobile: GridItemShow.hide,
                callback: () => {
                    window.person('show', item.person?.personId)
                },
            })

            let btnEdit = new GridButton({
                callback: () => editEntity(item.partnersPersonsId),
                label: 'Editar',
            })

            let line: GridLine = new GridLine()
            line.slots.push({ content: item.person.name })
            line.slots.push({ content: item['partner']?.name })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.startAt })
            line.slots.push({ content: [btnPerson, btnEdit] })
            grid.lines.push(line)
        }
    }
</script>

<Content>
    {#if step === 1}
        <Zact>
            <div class="date input-group limit-w_400 me-1">
                <label for="" class="input-group-text">Parceiro</label>
                <select class="form-select" bind:value={partnerId} on:change={loadEntities}>
                    <option value=""></option>
                    {#each partners as partner}
                        <option value={partner.partnerId}>{partner.person?.name}</option>
                    {/each}
                </select>
            </div>
            <div class="spacer" />
            {#if window.store.token.permissions.partnership.referrals.write}
                <button class="btn btn-secondary" on:click={newEntity}><Fa icon={faPlusCircle} /> Novo indicado</button>
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
    {/if}
    {#if step === 2}
        <Zact>
            <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
            <div class="spacer" />
            {#if !!entity.partnersPersonsId}
                <button class="btn btn-warning me-1" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
            {/if}
            <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
        </Zact>

        <Zframe title="Parceiro" class="h-space">
            <div class="grid-form">
                <div class="row">
                    <div class="col">
                        <ZentitySelect fonte="pessoa" label="Pessoa indicada" bind:value={entity.person} />
                    </div>
                    <div class="col">
                        <div class="date input-group">
                            <label for="" class="input-group-text">Parceiro</label>
                            <select class="form-select" bind:value={entity.partnerId}>
                                <option value=""></option>
                                {#each partners as partner}
                                    <option value={partner.partnerId}>{partner.person.name}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="input-group">
                            <label for="" class="input-group-text">Data da indicação</label>
                            <input type="date" bind:value={startAt} class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </Zframe>
    {/if}
    {#if step === 3}
        <!-- <AudienceShow on:close={showEntities} {audienceId} /> -->
    {/if}
</Content>
<LoadSpinner {show} />
